import { IS_EMAIL, IS_PHONE_NUMBER } from "../../utils/validators";
import { localisable } from "../../generic/localisable";
import { commonInputStyleProps } from "./constant";
const today = new Date().toISOString().split('T')[0];
export const formConfig = (intLeadDaysFrom: number, intLeadDaysTo: number) => {
    function daysToDate(days: number): string {
        const currentDate: Date = new Date(); // Get the current date
        currentDate.setDate(currentDate.getDate() + days); // Add the specified number of days

        const year: number = currentDate.getFullYear();
        const month: string = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based, so we add 1
        const day: string = currentDate.getDate().toString().padStart(2, '0');

        const formattedDate: string = `${day}-${month}-${year}`;

        return formattedDate;
    }
    const minDate: string = daysToDate(intLeadDaysFrom);
    const maxDate: string = daysToDate(intLeadDaysTo);
    return {
        firstName: {
            name: "firstName",
            required: true,
            label: localisable.firstName,
            type: 'text',
            placeholder: localisable.enterFirstName,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        lastName: {
            name: "lastName",
            required: true,
            label: localisable.lastName,
            type: 'text',
            placeholder: localisable.enterLastName,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        phone: {
            name: "phone",
            label: localisable.phone,
            type: 'tel',
            required: true,
            validate: IS_PHONE_NUMBER,
            placeholder: localisable.enterPhoneNumber,
            _placeholder: {
                textStyle: 'body1',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        email: {
            name: "email",
            label: localisable.email,
            type: 'email',
            required: true,
            validate: IS_EMAIL,
            placeholder: localisable.enterEmail,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        addressLine1: {
            name: "addressLine1",
            label: localisable.addressLine1,
            type: 'text',
            required: true,
            placeholder: localisable.enterAddressLine1,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '630px', md: '930px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        addressLine2: {
            name: "addressLine2",
            label: localisable.addressLine2,
            type: 'text',
            placeholder: localisable.enterAddressLine2,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '630px', md: '930px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        city: {
            name: "city",
            label: localisable.city,
            type: 'text',
            required: true,
            placeholder: localisable.enterCity,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        state: {
            name: "state",
            label: localisable.stateProvince,
            type: 'select',
            required: true,
            placeholder: localisable.selectState,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        zipCode: {
            name: "zipCode",
            label: localisable.zipCode,
            type: 'text',
            required: true,
            placeholder: localisable.enterZipCode,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        driverLicenseNumber: {
            name: "driverLicenseNumber",
            label: localisable.licenseNumber,
            type: 'text',
            placeholder: localisable.enterLicenseNumber,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        driverLicenseExpiration: {
            name: "driverLicenseExpiration",
            label: localisable.licenseExpiration,
            type: 'date',
            placeholder: localisable.selectLicenseExpiration,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        birthDate: {
            name: "birthDate",
            label: localisable.birthDate,
            type: 'date',
            placeholder: localisable.dateFormat,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryType: {
            name: "militaryType",
            label: localisable.militaryType,
            type: 'select',
            placeholder: localisable.selectMilitaryType,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryBranch: {
            name: "militaryBranch",
            label: localisable.militaryBranch,
            type: 'select',
            placeholder: localisable.selectMilitaryBranch,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryID: {
            name: "militaryID",
            label: localisable.militaryID,
            type: 'text',
            placeholder: localisable.enterMilitaryID,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryDeployedDate: {
            name: "militaryDeployedDate",
            label: localisable.militaryDeployedDate,
            type: 'date',
            placeholder: localisable.dateFormat,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryDivision: {
            name: "militaryDivision",
            label: localisable.militaryDivision,
            type: 'text',
            placeholder: localisable.enterMilitaryDivision,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryCommandingOfficer: {
            name: "militaryCommandingOfficer",
            label: localisable.commandingOfficer,
            type: 'text',
            placeholder: localisable.enterCommandingOfficer,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        militaryCommandingOfficerNumber: {
            name: "militaryCommandingOfficerNumber",
            label: localisable.commandingOfficerNumber,
            placeholder: localisable.enterCommandingOfficerNumber,
            resize: 'none',
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altFirstName: {
            name: "altFirstName",
            required: true,
            label: localisable.firstName,
            type: 'text',
            placeholder: localisable.enterFirstName,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altLastName: {
            name: "altLastName",
            required: true,
            label: localisable.lastName,
            type: 'text',
            placeholder: localisable.enterLastName,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altPhone: {
            name: "altPhone",
            label: localisable.phone,
            type: 'tel',
            required: true,
            validate: IS_PHONE_NUMBER,
            placeholder: localisable.enterPhoneNumber,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altEmail: {
            name: "altEmail",
            label: localisable.email,
            type: 'email',
            required: true,
            validate: IS_EMAIL,
            placeholder: localisable.enterEmail,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altAddressLine1: {
            name: "altAddressLine1",
            label: localisable.addressLine1,
            required: true,
            type: 'text',
            placeholder: localisable.enterAddressLine1,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '630px', md: '930px' }
            },
            wrapperProps: {
                w: { base: '100%', sm: 'fit-content' }
            }
        },
        altAddressLine2: {
            name: "altAddressLine2",
            label: localisable.addressLine2,
            type: 'text',
            placeholder: localisable.enterAddressLine2,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '630px', md: '930px' }
            },
            wrapperProps: {
                w: { base: '100%', sm: 'fit-content' }
            }
        },
        altCity: {
            name: "altCity",
            label: localisable.city,
            type: 'text',
            required: true,
            placeholder: localisable.enterCity,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altState: {
            name: "altState",
            label: localisable.state,
            type: 'text',
            required: true,
            placeholder: localisable.selectState,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        altZipCode: {
            name: "altZipCode",
            label: localisable.zipCode,
            type: 'text',
            required: true,
            placeholder: localisable.enterZipCode,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '294px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        unitType: {
            name: "unitType",
            required: true,
            label: localisable.unitType,
            type: 'select',
            placeholder: localisable.selectUnitType,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        insuranceType: {
            name: "insuranceType",
            required: true,
            label: localisable.insuranceType,
            type: 'select',
            placeholder: localisable.selectInsuranceType,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        period: {
            name: "period",
            label: localisable.period,
            type: 'select',
            required: true,
            placeholder: localisable.selectPeriod,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            }
        },
        moveInDate: {
            name: "moveInDate",
            label: "Move-In Date",
            type: 'date',
            required: true,
            placeholder: localisable.dateFormat,
            _placeholder: {
                textStyle: 'body2',
                color: 'input.placeholder'
            },
            inputStyleProps: {
                ...commonInputStyleProps,
                w: { base: '100%', sm: '303px', md: '453px' }
            },
            wrapperProps: {
                w: { sm: 'fit-content' }
            },
            min: minDate,
            max: maxDate
        },
    };
};
